import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f99f7fd")

_pushScopeId("data-v-4f99f7fd")
const _hoisted_1 = { class: "toc_loopCarVideo_main" }
const _hoisted_2 = { class: "toc_loopCarVideo_body" }
const _hoisted_3 = { class: "toc_loopCarVideo_body_cont" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "comTitle_main" }, [
  /*#__PURE__*/_createVNode("div", { class: "comTitle_left" }, "环车视频")
], -1)
const _hoisted_5 = { class: "playerCont" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetectPlayer = _resolveComponent("DetectPlayer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DetectPlayer, {
            class: "DetectPlayer",
            "play-data": _ctx.state.playData
          }, null, 8, ["play-data"])
        ])
      ])
    ])
  ]))
})